import { jsx as _jsx } from "react/jsx-runtime";
import CheckboxCheckedIcon from "@diligentcorp/atlas-react-icons/CheckboxChecked.js";
import CheckboxDefaultIcon from "@diligentcorp/atlas-react-icons/CheckboxDefault.js";
import CheckboxIndeterminateIcon from "@diligentcorp/atlas-react-icons/CheckboxIndeterminate.js";
const getCheckboxTokens = (tokens) => {
    return {
        checkbox: tokens.component.checkbox,
        radius: tokens.semantic.radius,
        shadow: tokens.semantic.shadow,
    };
};
const checkbox = (tokens) => {
    const { checkbox, radius, shadow } = getCheckboxTokens(tokens);
    return {
        MuiCheckbox: {
            defaultProps: {
                disableRipple: true,
                icon: _jsx(CheckboxDefaultIcon, {}),
                checkedIcon: _jsx(CheckboxCheckedIcon, {}),
                indeterminateIcon: _jsx(CheckboxIndeterminateIcon, {}),
            },
            styleOverrides: {
                root: {
                    padding: checkbox.padding.value,
                    borderRadius: radius.md.value,
                    alignSelf: "flex-start",
                    color: checkbox.borderColor.value,
                    "& svg": {
                        fontSize: checkbox.width.value,
                        height: checkbox.height.value,
                        width: checkbox.width.value,
                    },
                    "&:focus-within": {
                        boxShadow: shadow.focus.value.stringValue,
                    },
                    "&.Mui-disabled": {
                        color: checkbox.disabled.borderColor.value,
                    },
                },
            },
        },
    };
};
export default checkbox;
//# sourceMappingURL=checkbox.js.map